<div class="ds-card ds-card--gris">
  <div class="ds-card__cabecera">
    <span class="ds-card__titulo">{{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_UNIDADPRODUCTIVA' | translate }}</span>
    <button type="button" class="btn-action-premium ds-btn-icono-editar"
            title="{{ 'BTN_EDITAR' | translate }}">
      <span class="ds-icono-editar"></span>
    </button>
  </div>
  <ng-container *ngIf="!cargandoUnidadProductiva; else cargandoUnidadProductivaTpl">
    <div class="admsb-fila-datos">
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-nombre-negocio.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_NOMBRENEGOCIO' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ unidadProductiva.nombreNegocio }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-telefono-establecimiento.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_TELEFONOESTABLECIMIENTO' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ unidadProductiva.telefonoEstablecimiento | telefono }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-ubicacion.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_DIRECCION' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ unidadProductiva.direccion }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-ubicacion.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_CIUDAD' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ unidadProductiva.ciudad }}</span>
      </div>
      <div class="admsb-dato">
        <span class="admsb-dato__label">
          <img src="assets/icons/ico-actividad-economica.svg" alt="">
          {{ 'ADMINISTRADORSERVICIOSBANCARIOS.LBL_ACTIVIDADECONOMICACIIU' | translate }}
        </span>
        <span class="admsb-dato__valor">{{ unidadProductiva.actividadEconomica }}</span>
      </div>
    </div>
  </ng-container>
  <ng-template #cargandoUnidadProductivaTpl>
    <div class="ds-cargando">
      <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i>
      <span>{{ 'LBL_CARGANDO' | translate }}</span>
    </div>
  </ng-template>
</div>
